'use client'
import React, { useEffect } from 'react'
// import { isMobileDevice } from 'helpers/utilities'
import { useUploadResumeContext, withUploadResumeProvider } from './context'

import Main from './Main'
import Progress from './Progress'
import Success from './Success'
// import Failed from './Failed'
import { useMainResumeContext } from '../Main/context'
import SafeInfo from '../Common/SafeInfo'

const UploadResumePc = (props: { lang: string }) => {
  // const isMobile = isMobileDevice()
  const { getUserInfo, userInfo } = useMainResumeContext()
  const { step, setUserData } = useUploadResumeContext()

  useEffect(() => {
    setUserData(userInfo)
  }, [userInfo])

  // console.log('userInfo', userInfo)

  // return <Main {...props} userDetail={userInfo} />
  // return <Progress {...props} />
  // return <Success {...props} userDetail={userInfo} getUserInfo={getUserInfo} />

  return (
    <>
      {step == 1 && <Main {...props} userDetail={userInfo} />}
      {step == 2 && <Progress {...props} />}
      {step == 3 && <Success {...props} userDetail={userInfo} getUserInfo={getUserInfo} />}
      {/* {step == 4 && <Failed {...props} userDetail={userInfo} getUserInfo={getUserInfo} />} */}
      <div style={{ marginBottom: '20px' }}>
        <SafeInfo lang={props?.lang} />
      </div>
    </>
  )
}

export default withUploadResumeProvider(UploadResumePc)
